export const toNumber = (value, fixed=4) => {
    return (
        Number(value.toFixed(fixed))
    )
}